<p>
  detalle-reporte-asistencia works!
</p>
